module.exports = require('../impls/array-last-or/array-last-or.js').arrayLastOr;